import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "./Privacy.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function Privacy() {
  const [t] = useTranslation("common");
  const [lang, setLang] = useState("");

  const privacyPolicy = (
    <>
      <h1>{t("privacy1")}</h1>
      <p>
        <strong>{t("privacy2")}</strong>
      </p>
      <p>{t("privacy3")}</p>

      <h2>{t("privacy4")}</h2>
      <p>{t("privacy5")}</p>

      <h3>{t("privacy6")}</h3>
      <ul>
        <li>{t("privacy7")}</li>
        <li>{t("privacy8")}</li>
        <li>{t("privacy9")}</li>
      </ul>

      <h3>{t("privacy10")}</h3>
      <ul>
        <li>{t("privacy11")}</li>
        <li>{t("privacy12")}</li>
        <li>{t("privacy13")}</li>
      </ul>

      <h2>{t("privacy14")}</h2>
      <ul>
        <li>{t("privacy15")}</li>
        <li>{t("privacy16")}</li>
        <li>{t("privacy17")}</li>
        <li>{t("privacy18")}</li>
      </ul>
      <p>{t("privacy19")}</p>

      <h2>{t("privacy20")}</h2>
      <ul>
        <li>{t("privacy21")}</li>
        <li>{t("privacy22")}</li>
        <li>{t("privacy23")}</li>
      </ul>

      <h2>{t("privacy24")}</h2>
      <ul>
        <li>{t("privacy25")}</li>
        <li>{t("privacy26")}</li>
        <li>{t("privacy27")}</li>
      </ul>

      <h2>{t("privacy28")}</h2>
      <p>{t("privacy29")}</p>

      <h2>{t("privacy30")}</h2>
      <p>{t("privacy31")}</p>
      <p>{t("privacy32")}</p>

      <h2>{t("privacy33")}</h2>
      <p>{t("privacy34")}</p>
      <ul>
        <li>{t("privacy35")}</li>
        <li>{t("privacy36")}</li>
        <li>{t("privacy37")}</li>
        <li>{t("privacy38")}</li>
        <li>{t("privacy39")}</li>
        <li>{t("privacy40")}</li>
      </ul>
      <p>{t("privacy41")}</p>

      <h2>{t("privacy42")}</h2>
      <p>{t("privacy43")}</p>

      <h2>{t("privacy44")}</h2>
      <p>{t("privacy45")}</p>

      <h2>{t("privacy46")}</h2>
      <p>{t("privacy47")}</p>
      <p>
        <strong>{t("privacy48")}</strong>
        <br />
        {t("privacy49")}
        <br />
        {t("privacy50")}
      </p>
    </>
  );

  useEffect(() => {
    if (localStorage.getItem("lang") === "hr") {
      setLang("hr");
    } else {
      setLang("en");
    }
  }, [lang]);

  return (
    <div>
      <Header />
      <div className="privacyMain">
        <div className="font privacyDiv">
          <div style={{ padding: "2rem", maxWidth: "900px", margin: "0 auto" }}>
            {privacyPolicy}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
